var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(-556 -304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 24,
    height: 24,
    transform: "translate(556 304)",
    fill: "#e6e6e6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433",
    transform: "translate(-1 1.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    d: "M558.864,555.708v2.9a.969.969,0,0,0,.969.969h13.242a.969.969,0,0,0,.969-.969V544.079l-6.912-6.912h-7.3a.969.969,0,0,0-.969.969v8.8",
    transform: "translate(5.098 -234.274)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M568.125,537.167v6.494a.418.418,0,0,0,.418.418h6.494",
    transform: "translate(4.105 -234.274)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 15.686,
    height: 8.548,
    rx: 0.989,
    transform: "translate(560 312.773)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(562.384 314.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M560.165,551.424a1.287,1.287,0,0,0-.519-.506,1.615,1.615,0,0,0-.773-.179h-1.881v4.694h.884v-1.82h1a1.616,1.616,0,0,0,.773-.178,1.273,1.273,0,0,0,.519-.5,1.638,1.638,0,0,0,0-1.509Zm-.8,1.059a.492.492,0,0,1-.189.2.531.531,0,0,1-.279.073h-1.02v-1.169h1.02a.537.537,0,0,1,.282.073.481.481,0,0,1,.187.207.682.682,0,0,1,.067.309A.659.659,0,0,1,559.364,552.483Z",
    transform: "translate(-556.991 -550.739)",
    fill: "#363639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M563.948,551.51a1.4,1.4,0,0,0-.631-.574,2.332,2.332,0,0,0-1-.2h-1.553v4.694h1.549a2.25,2.25,0,0,0,1.02-.209,1.427,1.427,0,0,0,.625-.588,1.8,1.8,0,0,0,.207-.884v-1.33A1.8,1.8,0,0,0,563.948,551.51Zm-.7,2.267a.752.752,0,0,1-.239.594.991.991,0,0,1-.675.209h-.688v-2.989h.688a.992.992,0,0,1,.675.211.75.75,0,0,1,.239.594Z",
    transform: "translate(-556.883 -550.739)",
    fill: "#363639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4742",
    "data-name": "Path 4742",
    d: "M567.692,551.592v-.852h-3.083v4.694h.884v-1.862h1.844v-.852h-1.844v-1.127Z",
    transform: "translate(-556.774 -550.739)",
    fill: "#363639"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.4386bf3c2b4970e6213756603db1fa61.svg";
export { ForwardRef as ReactComponent };